import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, Signal } from '@angular/core';
import { AttachmentEntityType, ResolvedAttachment } from '../../../core/models/attachment.model';
import { AttachmentService } from '../../../core/services/attachment.service';
import { PhotoThumbnailComponent } from '../photo-thumbnail/photo-thumbnail.component';

/**
 * Reactive photo strip for one entity. Each instance owns its own query on
 * the attachments table, so a timeline of N rows stays live without the
 * parent tracking attachment ids.
 */
@Component({
  selector: 'app-attachment-strip',
  standalone: true,
  imports: [PhotoThumbnailComponent],
  templateUrl: './attachment-strip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './attachment-strip.component.css',
})
export class AttachmentStripComponent implements OnInit {
  private attachmentService = inject(AttachmentService);

  entityType = input.required<AttachmentEntityType>();
  entityId = input.required<string>();

  attachments!: Signal<ResolvedAttachment[]>;
  photoUrls = computed(() => this.attachments().map((a) => a.data_url).filter(Boolean));

  ngOnInit(): void {
    this.attachments = this.attachmentService.createResolvedQueryFor(this.entityType(), this.entityId()).data;
  }
}
